import { render, staticRenderFns } from "./ReportPayment.vue?vue&type=template&id=b2598d94&"
import script from "./ReportPayment.vue?vue&type=script&lang=js&"
export * from "./ReportPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports